export default "__VITE_ASSET__W9NByw2Y__"